import { render, staticRenderFns } from "./HistorialPaymentResponsive.vue?vue&type=template&id=5fbc2824&scoped=true"
import script from "./HistorialPaymentResponsive.vue?vue&type=script&lang=js"
export * from "./HistorialPaymentResponsive.vue?vue&type=script&lang=js"
import style0 from "./HistorialPaymentResponsive.vue?vue&type=style&index=0&id=5fbc2824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc2824",
  null
  
)

export default component.exports